import { useAppDispatch, useAppSelector } from '@/store/store-hooks'
import { ContentViewerActions } from '@/content-viewer/store/slice'
import { ViewerOpenContextKind, type ViewerOpenContext } from '@/content-viewer/store/schemas'
import { UserFileRead } from '@/uppy-file-upload/schemas'
import { buildUserFileViewerSession } from '@/user_files/files/utils/build-user-file-viewer-session'
import { useCallback } from 'react'

type ViewUserFileContext = Extract<ViewerOpenContext, { kind: ViewerOpenContextKind.DRIVE_FILE | ViewerOpenContextKind.SELECTED_FILE }>

type ViewUserFileOptions = {
  context?: ViewUserFileContext
}

export function useViewUserFile() {
  const dispatch = useAppDispatch()
  const activeMatterId = useAppSelector((state) => state.mattersState.activeMatterId)

  return useCallback(
    (file: UserFileRead, options: ViewUserFileOptions = {}) => {
      const context = options.context ?? {
        kind: ViewerOpenContextKind.DRIVE_FILE,
        ...(activeMatterId ? { matterId: activeMatterId } : {}),
      }
      const session = buildUserFileViewerSession({
        userFile: file,
        context,
      })
      if (!session) return

      dispatch(
        ContentViewerActions.setContentViewerSession({
          session,
        })
      )
    },
    [activeMatterId, dispatch]
  )
}
